import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import { PriceLoadingWrapper, StyledCheckbox } from "./styled";

import { StyledRow } from "App/global-style";
import { Checkbox } from "Components/Form/Checkbox";
import { PriceWrapper } from "Components/InsuranceDetailsCard";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { AdviceProductChangeType } from "Store/advice/interfaces";
import React from "react";

interface Props {
  insuranceId: string;
  insuranceType: string;
  price: number;
  handleCustomerChange: (
    changeType: AdviceProductChangeType,
    changeValue: number | boolean,
  ) => void;
  priceIsChanging?: boolean;
  priceIsLoading?: boolean;
}

const Price = (props: {
  loading: boolean;
  price: number;
  isChanging: boolean;
}): React.ReactElement => {
  if (props.loading) {
    return (
      <PriceLoadingWrapper>
        <ThemedSpinner id="ValueSpinner" black size="small" />
        <span className="ValueType">{VALUE_TYPE.NOK_MONTH}</span>
      </PriceLoadingWrapper>
    );
  }

  return (
    <NumberValue
      as="p"
      className="InsuranceMonthlyPrice"
      value={props.price}
      type={VALUE_TYPE.NOK_MONTH}
      boldValue
      largeValue
      disabledColor={props.isChanging}
    />
  );
};

export const AdviceCardHeader = ({
  insuranceId,
  insuranceType,
  price,
  handleCustomerChange,
  priceIsChanging = false,
  priceIsLoading = false,
}: Props): React.ReactElement => {
  return (
    <StyledRow className="AdviceCardHeader">
      <StyledCheckbox className="InsuranceCheckbox">
        <Checkbox
          id={insuranceId}
          name={insuranceId}
          label={insuranceType}
          onChange={(e) => {
            const selected = e.target.checked;
            handleCustomerChange(
              AdviceProductChangeType.PRODUCT_CHECKBOX,
              selected,
            );
          }}
        />
      </StyledCheckbox>
      <PriceWrapper>
        <Price
          price={price}
          isChanging={priceIsChanging}
          loading={priceIsLoading}
        />
      </PriceWrapper>
    </StyledRow>
  );
};
